export const USERS_SERVICE_URL = 'user/';
export const POST_SERVICE_URL = 'post/';
